import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Input } from '@maxmilhas/hangar-components-atomic/public';

export const InputDate = ({ value, ...rest }) => {
  const [hasWrongDate, setHasWrongDate] = useState(false);
  const [hasLowerDate, setHasLowerDate] = useState(false);

  useEffect(() => {
    if (value) {
      const now = moment();
      const date = moment(value, 'DD/MM/YYYY');
      const diff = now.diff(date, 'days');

      if (value.length === 10 && moment(value, 'DD/MM/YYYY').isValid() && diff) {
        setHasWrongDate(false);
        if (diff < 0) {
          setHasLowerDate(false);
        } else {
          setHasLowerDate(true);
        }
      } else {
        setHasWrongDate(true);
      }
    }
  }, [value]);

  return (
    <>
      <Input
        value={value}
        hasError={hasWrongDate || hasLowerDate}
        placeholder="__/__/____"
        {...rest}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      />

      {(hasLowerDate || hasWrongDate) && (
        <p style={{ marginTop: 4, minHeight: 19, color: '#fb3b3b' }}>
          {hasLowerDate && `A data informada deve ser maior que ${moment().add(1, 'd').format('DD/MM/YYYY')}.`}
          {!hasLowerDate && hasWrongDate && 'A data não é uma data válida.'}
        </p>
      )}
    </>
  );
};

export default InputDate;